exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx?export=default" /* webpackChunkName: "component---src-pages-index-jsx" */)
}



exports.head = {

}

